import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
import productListState from './product-list-state.js';
const productListPricesState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productListPrices',
    service: Core.GetProductPrices,
    beforeRequest: ({ req, get }) => {
        const searchResult = get(productListState.response);
        const searchProducts = searchResult?.Products ?? [];
        const productIds = searchProducts.map(product => product?.product_id).filter(productId => !!productId);
        if (!productIds.length) {
            return;
        }
        const newRequest = {
            ProductIDs: productIds,
        };
        return newRequest;
    },
});
export default productListPricesState;
//# sourceMappingURL=product-list-prices-state.js.map